import { makeStyles } from '@material-ui/core/styles'
import { light } from '@material-ui/core/esm/styles/createPalette'

const useStyles = makeStyles(
	({ palette }) => ({
		root: {
			'&$readonly, &:not($focused)': {
				'& $inputRoot': {
					'& $input': {
						cursor: 'pointer',
						height: '100%',
					},
				},
			},
			'& $inputRoot': {
				padding: 0,
				'& $input:first-child': {
					paddingLeft: 14,
					paddingRight: 14,
				},
			},
		},
		readonly: {},
		inputRoot: {},
		focused: {},
		listBox: {
			boxSizing: 'border-box',
			backgroundColor: palette.common.white,
			color: light.text.secondary,
			'& ul': {
				padding: 0,
				margin: 0,
				direction: ({ localeTextDirection }) => localeTextDirection || 'ltr',
			},
		},
		field: {},
		input: {
			padding: '0 3px',
		},
		popupIndicator: {
			color: () => palette.common.placeholder,
			zIndex: 1,
		},
		divider: {
			'&:last-child': {
				display: 'none',
			},
		},
		transparent: {
			'& $popupIndicator': {
				color: ({ usePaperColors }) =>
					palette.calcContrastColor(
						palette.common.placeholder,
						palette.augmentColor({ main: palette.background[usePaperColors ? 'paper' : 'default'] }).light,
					),
				zIndex: 1,
			},
		},
	}),
	{ name: 'Form-Autocomplete' },
)

export default useStyles
